import { combineReducers, createStore } from "redux";
import { composeWithDevTools } from "@redux-devtools/extension";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import appStateReducer from "./data/reducers/Authentication/appState.reducer";
import PageLoaderReducer from "./data/reducers/Common/PageLoader/PageLoader.reducer";
import areaReducer from "./data/reducers/Area/area.reducer";
import areaFormReducer from "./data/reducers/Area/areaForm.reducer";
import doctorReducer from "./data/reducers/Doctor/doctor.reducer";
import doctorFormReducer from "./data/reducers/Doctor/doctorForm.reducer";
import help from "./data/reducers/Help/help.reducer";
import dashboardReducer from "./data/reducers/ProjectDashboard/dashboard.reducer";
import drawerReducer from "./data/reducers/Common/Drawer/drawer.reducer";
import FaqReducer from "./data/reducers/Faq/Faq.reducer";
import ReviewReducer from "./data/reducers/Review/Review.reducer";
import consultReducer from "./data/reducers/Consult/consult.reducer";
import labReducer from "./data/reducers/Lab/lab.reducer";
import AppointmentReducer from "./data/reducers/Appointment/appointment.reducer";
import profileReducer from "./data/reducers/Profile/profile.reducer";
import consultFormReducer from "./data/reducers/Consult/consultForm.reducer";
import labformReducer from "./data/reducers/Lab/labform.reducer";
import appointmentformReducer from "./data/reducers/Appointment/appointmentform.reducer";
import DoctorAvailabilityReducer from "./data/reducers/DoctorAvailability/DoctorAvailability.reducer";
import DoctorAvailabilityFormReducer from "./data/reducers/DoctorAvailability/DoctorAvailabilityForm.reducer";
import FaqFormReducer from "./data/reducers/Faq/FaqForm.reducer";
import helpFormReducer from "./data/reducers/Help/helpForm.reducer";
import LabtestFormReducer from "./data/reducers/LabTest/LabtestForm.reducer";
import doctorHolidayReducer from "./data/reducers/DoctorHoliday/doctorHoliday.reducer";
import doctorHolidayFormReducer from "./data/reducers/DoctorHoliday/doctorHolidayForm.reducer";
import leaveFormReducer from "./data/reducers/Leave/leaveForm.reducer";
import leaveReducer from "./data/reducers/Leave/leave.reducer";
import PatientReducer from "./data/reducers/Patient/patient.reducer";
import UserMasterReducer from "./data/reducers/User_Master/user_Master.reducer";
import UserMasterFormReducer from "./data/reducers/User_Master/user_MasterForm.reducer";

const rootReducer = combineReducers({
  appState: appStateReducer,
  pageLoader: PageLoaderReducer,
  area: areaReducer,
  doctor: doctorReducer,
  help: help,
  helpForm: helpFormReducer,
  dashboard: dashboardReducer,
  drawer: drawerReducer,
  faq: FaqReducer,
  FaqForm: FaqFormReducer,
  review: ReviewReducer,
  consult: consultReducer,
  lab: labReducer,
  appointment: AppointmentReducer,
  profile: profileReducer,
  consultform: consultFormReducer,
  doctorform: doctorFormReducer,
  labform: labformReducer,
  areaform: areaFormReducer,
  appointmentform: appointmentformReducer,
  DoctorAvailability: DoctorAvailabilityReducer,
  DoctorAvailabilityForm: DoctorAvailabilityFormReducer,
  labTest: LabtestFormReducer,
  doctorHoliday: doctorHolidayReducer,
  doctorHolidayForm: doctorHolidayFormReducer,
  Leave: leaveReducer,
  LeaveForm: leaveFormReducer,
  patient: PatientReducer,
  UserMaster: UserMasterReducer,
  UserMasterform: UserMasterFormReducer,
});

const persistConfig = {
  key: "crm-admin",

  storage,
  whitelist: ["appState", "dashboard"],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = createStore(persistedReducer, composeWithDevTools());

export const persistor = persistStore(store);

export default store;
